<div class="cross-container">

    <div *ngIf="!currReg" class="img-top">
        <img src="assets/img/golf.jpg" />
    </div>

    <div style="padding: 15px">
        <!-- style="background: linear-gradient(110deg, #ccc 64%, #ff9734 64%); padding:30px;" -->
        <!-- fdcd3b ff7d00 -->
        <div class="cross-row">
            <div class="cross-col-12" style="display: flex; justify-content: center;">
                <h1>{{ 'Cerca il tuo Golf Club' | translate }}</h1>
            </div>
            <div class="cross-col-12" style="display: flex; justify-content: center;">
                <mat-form-field class="full-width" style="max-width: 250px;" #region>
                    <mat-select class="big-select" [(ngModel)]="currReg" #selectRegion (selectionChange)="getProvinces(currReg)">
                        <mat-option value="">Seleziona la Regione</mat-option>
                        <mat-option *ngFor="let regione of regioni" [value]="regione">{{ regione }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="currReg" class="full-width" style="max-width: 250px; margin-left: 50px;" #prov>
                    <mat-select class="big-select" [(ngModel)]="currProv" #selectProvince (selectionChange)="refreshGolfclubs()">
                        <mat-option value="">Seleziona la Provincia</mat-option>
                        <mat-option *ngFor="let provincia of province" [value]="provincia">{{ provincia }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

</div>

<div *ngIf="currReg || currProv" #gmap id="gmap" style="width:100%; height: 400px;"></div>

<div class="mt-40 pl-10 pr-10" *ngIf="golfclubs && golfclubs.length > 0">

    <div class="cross-row">
        <div class="cross-col-12 cross-col-sm-6 cross-col-md-4 cross-col-lg-4 px-20" *ngFor="let club of golfclubs; let i = index">

            <div class="club">  <!--  (click)="prenota(club.Login)" -->
                <!-- <div class="thumb-club" [ngStyle]="{'background-image': 'url(' + getThumb('public/' + club.ContactID + '/' + club.Image, i) + ')'}"></div> -->
                <div>
                    <div class="thumb-club"><img [src]="getThumb('public/' + club.ContactID + '/' + club.Image, i)"></div>
                    <div class="descr-club">
                        <h3 style="line-height: 1.2rem;">{{ club.Company }}</h3>
                        <div *ngIf="club.N[0]">{{ club.N[0] }} buche</div>
                        <div>{{ getAddress(club) }}</div>
                        <div>{{ club.Email }}</div>
                        <div>{{ club.Phone }}</div>
                    </div>
                </div>
                <div class="descr-club">
                    <a *ngIf="club.WebSite" target="_blank" [href]="getWebSite(club.WebSite)" class="mdc-button mat-secondary tickets_open">Sito Web</a>
                    <a style="margin-left: 10px;" (click)="prenota(club.Login)" class="mdc-button mat-primary tickets_open">Prenota</a>
                </div>
            </div>

        </div>
    </div>

</div>